import { render, staticRenderFns } from "./DepositTransfer.vue?vue&type=template&id=a8a26f56&scoped=true&"
import script from "./DepositTransfer.vue?vue&type=script&lang=js&"
export * from "./DepositTransfer.vue?vue&type=script&lang=js&"
import style0 from "./DepositTransfer.vue?vue&type=style&index=0&id=a8a26f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a26f56",
  null
  
)

export default component.exports